import { Loading } from "@foris/avocado-suite";
import { sessionAssignationStore } from "@context/sessionAssignation";
import { useSessionAssignationWorkflow } from "@services/collections/session-assignation";
import { AppContext } from "../../context/EditSessionsContext";
import { useSessionAssignationResultsContext } from "../../hooks/session-assignation";
import ResultEdit from "../ResultEdit/ResultEdit";

interface SessionAssignationResultsProps {
  heightHeader: number;
  onReload: () => Promise<boolean>;
}

const SessionAssignationResults = ({ heightHeader, onReload }: SessionAssignationResultsProps) => {
  const { context, phase, validated, issues } = useSessionAssignationResultsContext(onReload);
  const workflow = useSessionAssignationWorkflow();
  if (!context) return phase === "committing" ? <Loading /> : null;
  return (
    <AppContext.Provider value={context}>
      {phase === "committing" && <Loading />}
      <ResultEdit
        heightHeader={heightHeader}
        sessionAssignment={{
          commit: workflow.commit,
          canCommit: phase === "results" && validated?.result.userCanSkipValidations === true,
          busy: phase === "committing",
          issues,
          onBack: () =>
            phase === "saved" ? onReload() : sessionAssignationStore.getState().backToEditing(),
          onReload,
        }}
      />
    </AppContext.Provider>
  );
};

export default SessionAssignationResults;
